<template>
  <div style="display: none; position: absolute;">
    <input type="email" name="dummy-email" autocomplete="username" />
  </div>
</template>

<script>
export default {}
</script>
